<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/notification-client">Notificações clientes </router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Nova notificação</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <form @submit="save">
            <div class="row mt-4">
                <div class="col-xl-7 col-md-7 col-sm-12">
                    <div class="card shadow mb-4">
                        <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h6 class="m-0 font-weight-bold text-primary">Dados da notificação</h6>
                        </div>
                        <!-- Card Header - Dropdown -->
                        <div class="card-body">
                            <div class="row">
                                <div class="col-xl-3 col-md-3 col-sm-12">
                                    <label for="">Data notificação*</label>
                                    <input type="date" class="form-control" v-model="notification.deadline">
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12">
                                    <label for="">Hora notificação*</label>
                                    <multiselect v-model="notification.time" :options="time_options"
                                        placeholder="Selecione uma opção" :select-label="'Clique para selecionar'"
                                        :deselect-label="'Clique para remover'">
                                        <template #noResult>
                                            Nenhum horário encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12">
                                    <label for="">Repetir operação*</label>
                                    <div class="input-group mb-3">
                                        <multiselect v-model="repeat_multiselect" :options="repeat_options"
                                            placeholder="Selecione uma opção" :select-label="'Clique para selecionar'"
                                            :custom-label="repeatWithLang" :deselect-label="'Clique para remover'"
                                            @select="handleSelectRepeat">
                                            <template #noResult>
                                                Opção não encontrada.
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12" v-if="notification.repeat == '1'">
                                    <label for="">Dia mês para notificação*</label>
                                    <div class="input-group mb-3">
                                        <multiselect v-model="notification.day_repeat"
                                            :options="issuing_day_repeat_options" placeholder="Selecione uma opção"
                                            :select-label="'Clique para selecionar'"
                                            :deselect-label="'Clique para remover'"
                                             @select="handleSelectDayRepeat">
                                            <template #noResult>
                                                Nenhum dia encontrado.
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Título*</label>
                                    <input type="text" class="form-control"
                                        placeholder="Ex: Aviso envio extrato bancário" v-model="notification.title">
                                </div>
                            </div>
                            <div class="row mt- mt-3">
                                <div class="col-lg-12 col-xs-12 col-sm-12">
                                    <label for="">Descrição da notificação*</label>
                                    <editorTextSimple @update-text="updateDescription"
                                        :modelValue="notification.description" placeholderSend="Solicitamos o envio...."
                                        ref="myChild">
                                    </editorTextSimple>
                                </div>
                            </div>
                            <div class="row mt-3 float-right">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                            class="fa fa-save"></i> Cadastrar</button>
                                           
                                    <router-link to="/notification" class="btn btn-danger ml-3"><i
                                            class="fa fa-times"></i>
                                        Cancelar</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-5 col-md-5 col-sm-12">
                    <div class="card shadow mb-4">
                        <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h6 class="m-0 font-weight-bold text-primary">Clientes a serem notificados</h6>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Selecione um ou mais clientes*</label>
                                    <multiselect v-model="client_multiselect" :options="clients_options"
                                        :custom-label="clientWithLang" placeholder="Selecione uma opção"
                                        @select="handleSelectClient">

                                        <template #noResult>
                                            Nenhum cliente encontrado.
                                        </template>
                                    </multiselect>
                                    <button type="button" class="btn btn-success mt-2" @click="addAllClientList"><i
                                            class="fa fa-check"></i>Adicionar
                                        todos os clientes</button>
                                    <button type="button" class="btn btn-danger mt-2 ml-2" @click="removeAllClientList"><i
                                            class="fa fa-ban"></i>
                                        Remover todos os
                                        clientes</button>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Lista de clientes adicionados</label>
                                    <div class="table-responsive limitHeightListClient">
                                        <table class="table" id="dataTable" width="100%" cellspacing="0">
                                            <thead v-if="client_selected.length > 0">
                                                <tr>
                                                    <th>Documento</th>
                                                    <th>Nome</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(client, index) in client_selected" :key="index">
                                                    <td>{{ client.document }} </td>
                                                    <td>{{ client.name }} </td>
                                                    <td><button class="btn btn-danger"
                                                            @click="removeClientList(client.key)"><i
                                                                class="fa fa-trash"></i></button></td>
                                                </tr>
                                                <tr v-if="client_selected.length == 0">
                                                    <td class="text-center">Nenhum cliente selecionado</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

 
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import Multiselect from 'vue-multiselect'
import editorTextSimple from '../util/editor-text-simple.vue';


import 'vue-loading-overlay/dist/css/index.css';
export default {

    components: { Loading, Multiselect, editorTextSimple },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            issuing_day_repeat_options: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28'],
            time_options: ['01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '24:00'],
            repeat_multiselect: { type: '0', value: 'Não' },
            repeat_options: [{ type: '1', value: 'Sim' }, { type: '0', value: 'Não' }],
            notification: {
                title: '',
                time: '09:00',
                deadline: '',
                repeat: '0',
                description: ''
            },
            clients: [],
            clients_options: [],
            client_multiselect: '',
            client_selected: [],
            enable_error_list: false,
            errors: []
        }
    },

    computed: {
        isDisabled: function () {
            return this.notification.title != '' && this.notification.repeat != '' && this.client_selected.length > 0 && this.notification.deadline != '' && this.notification.time != '';
        }
    },
    mounted() {
        this.isLoading = false;
        const response = this.getclients();
        response.then(() => {
            this.clients_options = this.clients.map(client => ({
                key: client.id,
                value: 'Documento: ' + client.document_formatted + '| Nome: ' + client.name,
                name: client.name,
                document: client.document_formatted
            }));
        });

    },
    methods: {
        onCancel() { },
        repeatWithLang({ value }) {
            return value;
        },

        handleSelectRepeat(option) {
            this.notification.repeat = option.type;
        },

         handleSelectDayRepeat(option) {
            this.notification.day_repeat = option;
        },

        inListClientSelected(key) {
            let inserted = false;
            this.client_selected.forEach(client => {
                if (client.key == key) {
                    inserted = true;
                }
            });
            return inserted;
        },

        handleSelectClient(option) {
            if (!this.inListClientSelected(option.key)) {
                this.client_selected.push({ 'key': option.key, 'document': option.document, 'name': option.name });
            }
            this.client_multiselect = '';


        },

        updateDescription(description) {
            this.notification.description = description;
        },

        clientWithLang({ value }) {
            return value;
        },

        addAllClientList() {
            this.client_selected = [];
            this.clients.map(client => (this.client_selected.push({ 'key': client.id, 'document': client.document_formatted, 'name': client.name })));
        },

        removeAllClientList() {
            this.client_selected = [];
        },
        removeClientList(element) {
            const index = this.client_selected.findIndex(item => item.key === element);
            if (index > -1) {
                this.client_selected.splice(index, 1);
            }

        },
        async getclients() {
            this.loading = true;
            const response = await api.get('/client', { params: { 'all_clientes': true, 'status': 'Ativo' } })
                .then((response) => {
                    this.clients = response.data.data;
                    this.loading = false;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                });
            return response;

        },
        save(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            let clients_selected = JSON.stringify(this.client_selected);
            const formData = new FormData();
            formData.append('title', this.notification.title);
            formData.append('time', this.notification.time);
            formData.append('deadline', this.notification.deadline);
            formData.append('repeat', this.notification.repeat);
            formData.append('day_repeat', this.notification.day_repeat);
            formData.append('description', this.notification.description);
            formData.append('clients', clients_selected);
            api.post('/notification-client', formData)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Notificação cadastrada com sucesso!",
                        type: 'success'
                    });
                    this.notification = {};
                    this.client_selected = [];
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })
        },
       
    }
}
</script>

<style>
.limitHeightListClient {
    height: 320px;
    overflow-y: auto;
    scrollbar-color: darkblue lightgrey;
    border-bottom: 1px solid #e0e0e0;
}

.limitHeightListClient table {
    width: 100%;
    border-collapse: collapse;
}
</style>